/** @import { ComponentChildren } from "preact"; */

import html from "./html.js";

/**
 * @param {number} count
 * @param {string} singular
 * @param {string} [plural]
 */
export function pluralize(count, singular, plural = `${singular}s`) {
	return count === 1 ? singular : plural;
}

/**
 * @param {ComponentChildren[]} nouns
 * @param {ComponentChildren} [conjunction]
 */
export function list(nouns, conjunction = "and") {
	const items = nouns.slice();
	const last = items.pop();
	if (!items.length) return last;
	const allbutlast = items.map((item, i) => html`${i ? ", " : ""}${item}`);
	return html`${allbutlast} ${conjunction} ${last}`;
}

const segmenter = new Intl.Segmenter(undefined, { granularity: "word" });

/** @param {string} name */
export function shortenName(name) {
	const segments = Array.from(segmenter.segment(name));
	let shortened = segments.shift()?.segment ?? "";
	if (segments.length) {
		const initial = segments.at(-1)?.segment[0];
		if (initial) shortened = `${shortened} ${initial}`;
	}
	return shortened;
}
